import s from '../styles/dashboard.module.css';

interface Props {
  number: string;
  title: string;
}

const Chapter = ({ number, title }: Props) => (
  <div className={s.chapter}>
    <span className={s.chapterNum}>{number}</span>
    <h2 className={s.chapterTitle}>{title}</h2>
  </div>
);

export default Chapter;
